import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from './graphql';
import { initI18n } from './locale/i18n';
import { GlobalStyle } from './GlobalStyle';
import { Ssp } from './components/Ssp';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

initI18n();

const renderAppToDom = () =>
    root.render(
        <ApolloProvider client={apolloClient}>
            <GlobalStyle />
            <Ssp />
        </ApolloProvider>
    );

if (
    process.env.NODE_ENV === 'development' &&
    !process.env.REACT_APP_DISABLE_SERVICE_WORKER
) {
    const { worker } = require('./mocks/browser');
    worker.start().then(renderAppToDom);
} else {
    renderAppToDom();
}
